import { Reducer } from 'redux';
import {
    MergeFieldsStateStatus,
    MergeFieldsActionTypes,
    MergeFieldsLoadSuccessAction,
    MergeFieldsState,
    MergeFieldsMaxFieldsValuesMap
} from './types';


const defaultState: MergeFieldsState = {
    status: MergeFieldsStateStatus.DEFAULT,
    data: null
};


const loadStart = (state: MergeFieldsState): MergeFieldsState => ({
    ...state,
    status: MergeFieldsStateStatus.LOADING
});

const loadSuccess = (state: MergeFieldsState, action: MergeFieldsLoadSuccessAction): MergeFieldsState => ({
    ...state,
    status: MergeFieldsStateStatus.LOADED,
    data: action.payload.data,
    maxFieldsValuesMap: action.payload.data.MaxFieldsValues.reduce((obj, current) => ({...obj, [current.Name]: current }),{}) as MergeFieldsMaxFieldsValuesMap
});

const loadError = (state: MergeFieldsState): MergeFieldsState => ({
    ...state,
    ...state,
    status: MergeFieldsStateStatus.LOAD_ERROR
});

const reducer: Reducer<MergeFieldsState> = (
    state: MergeFieldsState = defaultState,
    action
): MergeFieldsState => {
    switch (action.type) {
        case MergeFieldsActionTypes.LOAD_START:
            return loadStart(state);
        case MergeFieldsActionTypes.LOAD_SUCCESS:
            return loadSuccess(state, action as MergeFieldsLoadSuccessAction);
        case MergeFieldsActionTypes.LOAD_ERROR:
            return loadError(state);
        default:
            return state;
    }
};

export { reducer as mergeFields };

export default reducer;
